export default "__VITE_ASSET__QGooECvB__"